
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.786.009a.771.771 0 00-.552.224.771.771 0 000 1.093l7.678 7.677-7.678 7.678a.771.771 0 000 1.092.771.771 0 001.092 0l7.678-7.677 7.678 7.677a.771.771 0 001.092 0 .771.771 0 000-1.092l-7.678-7.678 7.678-7.677a.771.771 0 000-1.093.771.771 0 00-.54-.224.771.771 0 00-.552.224L9.004 7.911 1.326.233A.771.771 0 00.786.01z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    